<template>
  <Layout :footer-style="2" header-class="header-left-align" nav-alignment="right" :header-transparency="false" :show-top-header="true" buy-button-class="btn-default btn-small">
    <!-- Start Slider Area -->
    <div class="slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow">
      <VueSlickCarousel v-bind="sliderSetting" v-if="sliderData.length!==0">
        <div v-for="(slider, index) in sliderData" :key="index" class="single-slide">
          <div class="height-950  bg_image">
            <img class="slider-img" :src="slider.image"></img>
          </div>
        </div>
      </VueSlickCarousel>
    </div>

    <HomeNews :news-list="newsList"/>

  </Layout>
</template>

<script>


import Layout from '../../components/common/Layout'
import SectionTitle from '../../components/elements/sectionTitle/SectionTitle'
import Separator from '../../components/elements/separator/Separator'
import VueSlickCarousel from 'vue-slick-carousel'

import Testimonial from '../../components/elements/testimonial/Testimonial'
import Portfolio from '../../components/elements/portfolio/Portfolio'
import ServiceFive from '../../components/elements/service/ServiceFive'
import Progressbar from '../../components/elements/progressbar/Progressbar'
import AboutEight from "../../components/elements/about/AboutEight";
import HomeNews from "../home-site/HomeNews"

export default {
  name: 'Home',
  components: {
    HomeNews,
    AboutEight,
    Progressbar,
    ServiceFive,
    Portfolio,
    Testimonial,
    Separator,
    SectionTitle,
    Layout,
    VueSlickCarousel
  },

  data() {
    return {
      sliderSetting: {
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: false,
        arrows: true,
        autoplay: true,
        //speed: 5000,
        autoplaySpeed: 8000,
        pauseOnDotsHover: false,
        pauseOnFocus: false,
        pauseOnHover: false,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 993,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 580,
            settings: {
              slidesToShow: 1,
            }
          },
          {
            breakpoint: 481,
            settings: {
              slidesToShow: 1,
            }
          }
        ]
      },
      sliderData: [],
      newsList:[],

    }
  },
  created() {
    this.getPic();
  },
  methods:{
    async getPic(){

      await this.postRequest('/system/web/listHome').then(resp=>{

        if(resp.data){
          let   assertList = [];
          resp.data.pics.forEach(item =>{
            var fileUrl = item.url;
            fileUrl = window.location.protocol+"//"+window.location.host+process.env.VUE_APP_BASE_API+fileUrl;
            var picData={
              image: fileUrl
            }
            assertList.push(picData);

          })
          let newsData = resp.data.news;
          newsData.forEach(item =>{
            if(item.thumbUrl){
              var fileUrl = item.thumbUrl;
              fileUrl = window.location.protocol+"//"+window.location.host+process.env.VUE_APP_BASE_API+fileUrl;
              item.thumbUrl = fileUrl;
            }else{
              item.thumbUrl = "";
            }

          })

          this.sliderData = assertList;
          this.newsList = newsData;

        }
      })
    },

    getBase64(imgUrl) {
      return new Promise((resolve, reject) => {
        if (!imgUrl) {
          reject('请传入imgUrl内容')
        }
        if (/\.(png|jpe?g|gif|svg)(\?.*)?$/.test(imgUrl)) {
          window.URL = window.URL || window.webkitURL
          var xhr = new XMLHttpRequest()
          xhr.open('get', imgUrl, true)
          xhr.responseType = 'blob'
          xhr.onload = function() {
            if (this.status == 200) {
              // 得到一个blob对象
              var blob = this.response
              const oFileReader = new FileReader()
              oFileReader.onloadend = function(e) {
                const base64 = e.target.result
                resolve(base64 || '')
              }
              oFileReader.readAsDataURL(blob);
            }
          }
          xhr.send()
        } else {
          // 非图片地址
          reject('非(png/jpe?g/gif/svg等)图片地址')
        }
      })
    },
  }
}
</script>

<style >
.slider-img{
  width: 100%;
  height: 100%;
}
</style>